import AddIcon from "@material-ui/icons/Add";
import ContactsIcon from "@material-ui/icons/Contacts";
import Typography from "@material-ui/core/Typography";
import React, { useState } from "react";

import Button from "../../../../components/elements/Button";
import CreateAdvertiserModal from "../../../../components/Advertisers/CreateAdvertiserModal";
import classes from "./NoAdvertisersFound.module.scss";

const NoAdvertisersFound = () => {
  const [isCreateAdvertiserModalOpen, setIsCreateAdvertiserModalOpen] = useState(false);

  const handleOpenCreateAdvertiserModal = () => {
    setIsCreateAdvertiserModalOpen(true);
  };

  const handleCloseCreateAdvertiserModal = () => {
    setIsCreateAdvertiserModalOpen(false);
  };

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <ContactsIcon className={classes.icon} />

        <div>
          <Typography variant="h2">Advertisers</Typography>
          <Typography>Create, edit and view Advertiser accounts.</Typography>
          <Button onClick={handleOpenCreateAdvertiserModal}>
            Create New Advertiser <AddIcon />
          </Button>
        </div>

        <CreateAdvertiserModal isOpen={isCreateAdvertiserModalOpen} handleClose={handleCloseCreateAdvertiserModal} />
      </div>
    </div>
  );
};

export default NoAdvertisersFound;
